import React from 'react'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

function RoundedFilledLoadingButton(props: LoadingButtonProps) {
  const { loading, sx, children, ...rest } = props
  return (
    <LoadingButton
      sx={{
        textTransform: 'capitalize',
        padding: '8px 16px',
        backgroundColor: '#0000FF',
        color: 'white',
        '&:hover': {
          backgroundColor: '#000869'
        },
        '&:active': {
          backgroundColor: '#000869'
        },
        '&:disabled': {
          color: 'none',
          backgroundColor: '#9AA5B1'
        },
        ...sx
      }}
      loading={loading}
      {...rest}
    >
      {children}
    </LoadingButton>
  )
}

export default RoundedFilledLoadingButton
